// src/deviceLocale.ts
function deviceLocale() {
  return Intl.DateTimeFormat().resolvedOptions().locale;
}
export {
  deviceLocale
};
//# sourceMappingURL=deviceLocale.mjs.map